module.exports = __webpack_public_path__ + "img/banner.3fcb8960.png";